import React, {useRef} from 'react'
import {PropTypes} from 'prop-types'
import i18n from 'i18next'
import {getCurrentWeek} from 'ag-common/tools/dates'
import ProgressOverview from '#components/o/MeineAusbildung/ProgressOverview'
import {CalendarConfig, CalendarType} from '#tools/calendarConfig'
import AppointmentsCell from '#components/m/Versetzungsplan/AppointmentsCell'
import CalendarHeaderMonthly from '#components/o/Versetzungsplan/CalendarHeaderMonthly'
import useCurrentUser from '#hooks/store/useCurrentUser'
import CalendarHeaderYearly from '#components/o/Versetzungsplan/CalendarHeaderYearly'

function VersetzungsplanDashboard(props) {
  const {versetzungsplaene} = props
  const targetRef = useRef()
  const calendarConfig = CalendarConfig[CalendarType.DASHBOARD]

  const date = calendarConfig.getInitialDate()
  const startOfCalendar = calendarConfig.getStartOfCalendar(date)
  const endOfCalendar = calendarConfig.getEndOfCalendar(date)

  const showEmptyTile = !versetzungsplaene || versetzungsplaene.length === 0

  if (showEmptyTile) {
    return <EmptyTile />
  }

  const currentUser = useCurrentUser()

  return (
    <ProgressOverview titleKey="menu_item_versetzungsplan" showProgressbar={false}>
      <div data-testid="versetungsplandashboard" className="versetzungsplandashboard">
        <div className="calendar calendar--monthly" ref={targetRef}>
          <CalendarHeaderMonthly
            date={date}
            startOfCalendar={startOfCalendar}
            endOfCalendar={endOfCalendar}
            calendarType={CalendarType.DASHBOARD}
            isDashboardView={true}
            setCalendarType={() => {}}
          />
          <AppointmentsCell
            azubi={currentUser}
            calendarType={CalendarType.DASHBOARD}
            startOfCalendar={startOfCalendar}
            endOfCalendar={endOfCalendar}
            isDashboardView={true}
          />
        </div>
      </div>
    </ProgressOverview>
  )
}

function EmptyTile() {
  return (
    <ProgressOverview titleKey="menu_item_versetzungsplan" showProgressbar={false}>
      <div data-testid="versetungsplandashboardNoData" className="versetzungsplandashboard--empty">
        <span>{i18n.t('loading_dashboard_data_failed')}</span>
      </div>
    </ProgressOverview>
  )
}

VersetzungsplanDashboard.propTypes = {
  versetzungsplaene: PropTypes.object,
}

export default VersetzungsplanDashboard
